import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { initStateIFL, changeStep } from '../redux/actions/actions';
import Start from '../components/Start';
import Empty from '../components/Empty';
import { getIfloorplan, countView } from '../serverRequests/requests';
import { useRouter } from 'next/router';
import UnpublishedNotice from 'Ifloorplan/components/unpublishedNotice';
import ReactGA from 'react-ga4';

const Main = (props) => {
    const router = useRouter();
    const [isError, setIsError] = useState(false);
    const [author, setAuthor] = useState();
    const [whiteLabelInfo, setWhiteLabelInfo] = useState();
    const [landscapImg, setLandscapImg] = useState(null);
    const [embedded, setEmbedded] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined') return;
        const inIframe = window.self !== window.top;
        const forceEmbed = typeof window.location !== 'undefined' &&
            new URLSearchParams(window.location.search).has('embed');
        if (inIframe || forceEmbed) {
            setEmbedded(true);
            document.documentElement.classList.add('embedded');
        }
    }, []);

    useEffect(() => {
        ReactGA.initialize('G-XXXXXXXXXX');
        ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
        ReactGA.event({
            category: 'player',
            action: `player view aspect ratio ${(window.innerWidth / window.innerHeight).toFixed(1)}`,
            label: `aspect ratio ${(window.innerWidth / window.innerHeight).toFixed(1)}`,
            value: parseInt(window.innerWidth / window.innerHeight * 100),
        });
    }, []);

    useEffect(() => {
        let ifloorplan_id = router.query.id;
        if (ifloorplan_id) {
            getIfloorplan(ifloorplan_id)
                .then((res) => {
                    if (res[0] === undefined) {
                        setIsError(true);
                        setAuthor(res.author_id);
                        setWhiteLabelInfo(res.domain_uri);
                    } else {
                        setIsError(false);
                        props.initStateIFL(res[0]);
                        setLandscapImg(res[0])
                        if (res.length === 0) {
                            props.changeStep('empty');
                        } else {
                            props.changeStep('start');
                            if (res[0].published) {
                                countView(ifloorplan_id);
                            }
                        }
                    }
                })
                .catch(error => {
                    setIsError(true);
                    console.log(error)
                })
        }
    }, [router.query.id]);


    return (
        <div className={"mainWrapIfloorplan" + (embedded ? " embedded" : "")}>
            {isError ? <UnpublishedNotice author={author} whiteLabelInfo={whiteLabelInfo} /> :
                <>{props.step === "" && ""}
                    {props.step === "start" && <Start
                        landscapImg={landscapImg}
                        // landscapNewImg={landscapNewImg}
                    />}
                    {props.step === "empty" && <Empty />}</>}
        </div>
    )
}

const putState = (state) => {
    return {
        step: state.step,
    }
}

const putActions = (dispatch) => {
    return {
        changeStep: (step) => dispatch(changeStep(step)),
        initStateIFL: (obj) => dispatch(initStateIFL(obj)),
    }
}

export default connect(putState, putActions)(Main);